import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, Observable } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { Owner } from 'src/app/shared/models/main/user'
import { DdcLoggerService } from '../log/ddc-logger.service'

export interface Notification {
  id: number
  type: 'like' | 'follow' | 'comment' | 'share' | 'system'
  actor: Owner | undefined
  shared_user?: Owner
  content_title: string
  content_type: number
  object_id: number
  message?: string
  is_read: boolean
  created_at: string
  read_at?: string
  time_since: string
}

export interface NotificationResponse {
  count: number
  next?: string
  previous?: string
  results: Notification[]
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_notifications_page(page: number = 1): Observable<NotificationResponse> {
    this.logger.info(`NOTIFICATION | get_notifications_page | page: ${page}`)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get<{
        results: Notification[]
        count: number
      }>(`${Backend.HOST_CONTAINER + Backend.NOTIFICATIONS}?page=${page}`, httpOptions)
      .pipe(
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'NOTIFICATION | get_notifications_page | catchError | errorMessage: ' + errorMessage,
          )
          throw error // Re-throw to allow proper error handling
        }),
      )
  }

  mark_all_as_read(): Observable<any> {
    this.logger.info(`NOTIFICATION | mark_all_as_read`)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .post<any>(
        `${Backend.HOST_CONTAINER + Backend.NOTIFICATIONS + Backend.NOTIFICATIONS_MARK_AS_READ}`,
        {},
        httpOptions,
      )
      .pipe(
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'NOTIFICATION | mark_all_as_read | catchError | errorMessage: ' + errorMessage,
          )
          throw error // Re-throw to allow proper error handling
        }),
      )
  }
}
